import { useState } from 'react';
import { useTheme } from '../lib/useTheme';

/**
 * Toggles between light and dark themes; persists the choice to localStorage.
 * Lives in the icon rail's bottom utility cluster (§2.1), so it carries the
 * rail-item anatomy: 44×44 hit target wrapping a Ø40 resting --surface-2
 * icon circle (hover = +1 ladder step).
 */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  const [hovered, setHovered] = useState(false);
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className="focus-ring pressable"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'var(--rail-item-hit)',
        height: 'var(--rail-item-hit)',
        boxSizing: 'border-box',
        padding: 0,
        background: 'transparent',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
        flexShrink: 0,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 'var(--rail-item-visual)',
          height: 'var(--rail-item-visual)',
          borderRadius: '50%',
          background: hovered ? 'var(--surface-3)' : 'var(--surface-2)',
          color: hovered ? 'var(--rail-hover-text)' : 'var(--text-low)',
          transition: 'background 0.12s var(--ease-out), color 0.12s var(--ease-out)',
        }}
      >
        {isDark ? (
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </svg>
        ) : (
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
          </svg>
        )}
      </span>
    </button>
  );
}
